module.exports = __webpack_public_path__ + "static/media/RAKUTEN.7a971e06.svg";